import { Component } from "@angular/core";

@Component({
    selector: "gnl-spinner-overlay",
    templateUrl: "./ui-spinner.component.html",
    standalone: false
})
export class SpinnerComponent {}
